<template>
  <div v-if="social.length" class="d-flex social-widget">
    <v-btn
      v-for="({ link, icon }, keySocial) in social"
      :key="keySocial"
      :href="link"
      target="blank"
      class="mr-1 d-flex"
      width="40px"
      height="40px"
      icon
    >
      <v-icon color="white" size="20">
        {{ icon }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { getSocial } from "../../utils/getSocial";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>

<style lang="scss" scoped>
.social-widget {
  width: max-content;
}
</style>
